<template>
  <div>
    <div
      v-if="pipsSL !== 0"
      class="d-flex flex-column"
    >
      <span class="cell-line-one">
        <span class="red-text">{{ sl }}</span>
        <i
          id="copy"
          class="far fa-copy"
          :data-clipboard-text="sl"
        />
      </span>
      <span class="cell-line-two">{{ pipsSL }} PIPs</span>
    </div>
    <div
      v-else
      class="d-flex flex-column"
    >
      <span class="cell-line-one">
        <span
          class="red-text"
          style="filter: blur(.25rem);"
        >1000000</span>
        <i
          id="copy"
          class="far fa-copy"
          data-clipboard-text="Nice try 😉"
        />
      </span>
      <span class="cell-line-two">xxx PIPs</span>
    </div>
  </div>
</template>

<script>
import usePermissions from '@/composables/usePermissions'
import useRates from '@/composables/rates/useRates'
import toPIPs from '@/mixins/toPIPs'

export default {
  name: 'SigTp',
  setup() {
    const { access } = usePermissions()
    const { getLatestRate } = useRates()

    return {
      access,
      getLatestRate,
    }
  },
  data() {
    return {
      sl: 0,
    }
  },
  computed: {
    pipsSL() {
      const latestRate = this.getLatestRate({ instrument: this.params.data.instrument })
      const { sl } = this.params.data
      let pips

      if (latestRate) {
        pips = toPIPs(this.params.data.instrument, Math.abs(sl - latestRate[4]))
      }

      return pips
    },
  },
  beforeMount() {
    // this.params contains the cell & row information and is made available to this component at creation time
    this.sigTpRenderer(this.params)
  },
  methods: {
    sigTpRenderer(params) {
      const access = this.access.signal({ stratType: params.data.strategyType })
      if (access) {
        this.sl = params.data.sl
      }
    },
  },
}
</script>

<style>

</style>
